(function () {
  'use strict';
  /* eslint-disable */
  angular
    .module('sempraWebapp')
    .directive('dailyFinancesChart', dailyFinancesChartDirective)
    .controller('dailyFinancesChartController', dailyFinancesChartController);

  /** @ngInject */
  function dailyFinancesChartDirective($timeout) {
    return {
      restrict: 'E',
      scope: {
        data: '=',
        chartId: '=',
        currencyCode: '='
      },
      templateUrl: 'app/components/dailyFinancesChart/dailyFinancesChart.html',
      controller: 'dailyFinancesChartController',
      controllerAs: 'vm',
      link: function (scope, element, $window) {
        scope.vm.chartElementId = scope.chartId; // += scope.index;
        scope.vm.data = scope.data;
        scope.vm.currency = scope.currencyCode;
        angular
          .element(element.find('.chart'))
          .attr('id', scope.vm.chartElementId);
        $timeout(function () {
          scope.vm.initChart();
          scope.$watch('data', function (newValue, oldValue) {
            if (newValue !== oldValue) {
              scope.vm.data = newValue;
              scope.vm.refreshChart();
            }
          });
        }, 200);
      }
    };
  }

  /** @ngInject */
  function dailyFinancesChartController(
    $scope,
    $timeout,
    $translate,
    localeFilters
  ) {
    var vm = this;

    vm.chart = null;
    vm.chartElementId = 'dailyFinancesChart';
    vm.data = null;
    vm.initChart = createChart;
    vm.refreshChart = refreshChart;

    init();

    function init() {
      $scope.$on('$destroy', destroy);
    }

    function destroy() {
      if (vm.chart) {
        vm.chart.destroy();
      }
    }

    function createChart() {
      vm.chart = c3.generate({
        onresize: function () {
          //refreshChart();
          var that = this;
          $timeout(function () {
            that.redraw();
          }, 500);
        },
        bindto: '#' + vm.chartElementId,
        data: {
          columns: [
            [
              vm.data.facilityName,
              //vm.data.totalOnlinePayments,
              vm.data.totalCashPayments,
              vm.data.totalChangerMoney,
              vm.data.totalPosMoney
            ]
          ],
          type: 'bar',
          //labels: true,
          labels: {
            format: function (v, id, i, j) {
              return localeFilters.currency(v, vm.currency);
            }
          },
          color: function (color, d) {
            switch (d.x) {
              case 0:
                return 'cadetblue';
              case 1:
                return '#2E71D6';
              case 2:
                return '#639D00';
              case 3:
                return 'green';
            }
          }
        },
        legend: {
          show: false
        },
        bar: {
          width: {
            ratio: 0.5 // this makes bar width 50% of length between ticks
          }
        },
        axis: {
          x: {
            type: 'category',
            categories: [
              //$translate.instant('DAILY_FINANCES_ONLINE'),
              $translate.instant('DAILY_FINANCES_OFFLINE'),
              $translate.instant('DAILY_FINANCES_CHANGER'),
              $translate.instant("DAILY_FINANCES_POS")
            ],
            colors: {
              Sempra: '#FFAF12'
            }
          },
          y: {
            label: {
              text: '(' + vm.currency + ')'
            },
            tick: {
              format: function (y) {
                return localeFilters.number(y);
              }
            }
          }
        }
      });
    }

    function refreshChart() {
      vm.chart.load({
        columns: [
          [
            vm.data.facilityName,
            //vm.data.totalOnlinePayments,
            vm.data.totalCashPayments,
            vm.data.totalChangerMoney,
            vm.data.totalPosMoney
          ]
        ]
      });
    }
    /* eslint-enable */
  }
})();
